var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 0.923096L2.18262 13.8317C1.02877 14.2915 0.307617 15.4724 0.307617 16.8606V23.0625C0.307617 25.6046 3.048 27.2452 5.35569 26.0914L27.9999 14.7692L50.6442 26.0914C52.9518 27.2452 55.6922 25.6136 55.6922 22.8462V16.8606C55.6922 15.7067 54.9711 14.2915 53.8172 13.8317L27.9999 0.923096ZM27.9999 19.3846L2.18262 32.5096C1.02877 32.9694 0.307617 34.1503 0.307617 35.5385V41.5241C0.307617 44.0661 3.048 45.7067 5.35569 44.5529L27.9999 33.2308L50.6442 44.5529C52.9518 45.7067 55.6922 44.0751 55.6922 41.3077V35.3221C55.6922 34.1683 54.9711 32.9874 53.8172 32.2933L27.9999 19.3846Z",
    fill: "#3CA260"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.6f07c64b07c305568e29c3283a75d815.svg";
export { ForwardRef as ReactComponent };